import { render, staticRenderFns } from "./surface_post_actions.vue?vue&type=template&id=2824f02e&scoped=true&"
import script from "./surface_post_actions.vue?vue&type=script&lang=js&"
export * from "./surface_post_actions.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_actions.vue?vue&type=style&index=0&id=2824f02e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2824f02e",
  null
  
)

export default component.exports